import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface DeleteReportModalProps {
  open: boolean;
  reportTitle: string;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
}

export const DeleteReportModal: React.FC<DeleteReportModalProps> = ({
  open,
  reportTitle,
  onConfirm,
  onCancel,
  isSubmitting = false,
}) => (
  <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Excluir report</DialogTitle>
        <DialogDescription>
          Tem certeza que deseja excluir &quot;{reportTitle}&quot;? O report será removido permanentemente.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="gap-2 sm:gap-0">
        <Button variant="outline" onClick={onCancel} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button variant="destructive" onClick={onConfirm} disabled={isSubmitting}>
          {isSubmitting ? 'Excluindo...' : 'Excluir'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
